import apiClient from "./axiosClient"

const all_favbooks = (data) => {
  return apiClient.get(`/books/mefavs/`)
}

/**
 * Executes the petitions to handle the event of add/delete some book fo favorite's list.
 * @param {{user_id: string, book_id: string, addToFav: boolean}} body 
 * @returns []Promise 
 */
const handle_favorites = (body) => {
  return Promise.all([
    apiClient.post(`/books/handleFavorite/`, body),
    apiClient.post(`/users/handleFavorite/`, body)
  ]);
}

/**
 * Executes the request to get the books that have 'searchText' in the title.
 * @param {string} searchText 
 * @returns Promise
 */
const searchBooksByText = (searchText) => {
  return apiClient.get(`/books/${searchText}/title`);
}

/**
 * Executes the request to get tag books.
 * @returns Promise
 */
const getBooksBy = (field, value, limit=15, offset=1) => {
  return apiClient.get(`/books/${value}/${field}?limit=${limit}&offset=${offset-1}`);
}

/**
 * Executes the request to get random books.
 * @returns Promise
 */
const getRandomBooks = (limit=15, offset=1) => {
  return apiClient.get(`/books/random?limit=${limit}&offset=${offset-1}`);
}

/**
 * Executes the request to get random books.
 * @returns Promise
 */
const getSortedBooks = (field, order, limit=15, offset=1) => {
  return apiClient.get(`/books/sort/${field}/${order}?limit=${limit}&offset=${offset-1}`);
}

/**
 * Executes 
 * @returns Promise
 */
const getGroupBooks = ( field ) => {
  return apiClient.get(`/books/group/${field}/field`);
}

/**
 * Executes the request to get detailed information of some book.
 * @returns Promise
 */
const getBookById = (bookId) => {
  return apiClient.get(`/books/${bookId}`);
}

/**
 * Gets the book's id from localStorage.
 * @returns 
 */
const getBookId = () => {
  return localStorage.getItem("book");
}

/**
 * Gets wheter or not a book is already registered by ISBN13.
 * @param {string} isbn 
 * @returns 
 */
const checkISBN = (isbn) => {
  return apiClient.get(`books/isbn/${isbn}`);
}
/**
 * 
 * @param {*} data 
 * @returns 
 */
const createBook = (data) => {
  return apiClient.post(`/books/`, data, {
    headers: {
      "Content-type": "multipart/form-data"
    }
  });
}
/**
 * 
 * @param {*} bookId 
 * @param {*} data 
 * @returns 
 */
const updateBook = async (bookId, data) => {
  return apiClient.put(`/books/${bookId}`, data, {
    headers: {
      "Content-type": "multipart/form-data"
    }
  });
}


export {
  all_favbooks, 
  handle_favorites, createBook, updateBook,
  searchBooksByText, getSortedBooks, getGroupBooks,
  getBooksBy,
  getRandomBooks, getBookById, getBookId, checkISBN
};
